// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['nb_NO']  = {
  "name": "nb_NO",
  "day": {
    "abbrev": [
      "sø.",
      "ma.",
      "ti.",
      "on.",
      "to.",
      "fr.",
      "lø."
    ],
    "full": [
      "søndag",
      "mandag",
      "tirsdag",
      "onsdag",
      "torsdag",
      "fredag",
      "lørdag"
    ]
  },
  "month": {
    "abbrev": [
      "jan.",
      "feb.",
      "mars",
      "april",
      "mai",
      "juni",
      "juli",
      "aug.",
      "sep.",
      "okt.",
      "nov.",
      "des."
    ],
    "full": [
      "januar",
      "februar",
      "mars",
      "april",
      "mai",
      "juni",
      "juli",
      "august",
      "september",
      "oktober",
      "november",
      "desember"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d. %b %Y",
  "time24": "kl. %H.%M %z",
  "dateTime": "%a %d. %b %Y kl. %H.%M %z",
  "time12": "",
  "full": "%a %d. %b %H:%M:%S %z %Y"
}

